import {twJoin} from "tailwind-merge";
import type {CSSProperties} from "react";

export function GenericErrorComponent({
    error,
    className,
    style,
}: {
    error: string;
    className?: string;
    style?: CSSProperties;
    //
}) {
    return (
        <div
            className={twJoin(
                "w-full h-full",
                "bg-[#ffe9e9] text-[#ff0000]",
                "grid place-items-center",
                className,
            )}
            style={style}
        >
            Error: {error}
        </div>
    );
}
